import { enumChartRenderOrder, enumFillMode } from "../constants";
import { QElement } from "./QElement";
import { Globals } from "./Globals";
import { SVG_DrawBackground } from "../utils/SVG_DrawBackground";
import { XML_DrawBackground } from "../utils/XML_DrawBackground";

export class QAltBackground extends QElement {
  constructor() {
    super();
    this.fObjectName = "QAltBackground";
    this.fSrcPanel = null;
  }

  InitBackground(sourcePanel) {
    this.fSrcPanel = sourcePanel;
    this.SetAcceptsClicks(false);
    this.SetZPlane(enumChartRenderOrder.underlay);
  }

  DoRenderElement(drawBuffer) {
    if (Globals._accountInfo.ReadOnlyMode()) return; //TODO: Need to be more sophisticated.
    var ctx = drawBuffer.getContext("2d");

    var thickness = 1;

    ctx.save();
    ctx.strokeStyle = "#000000";
    ctx.fillStyle = "#b1b1b6";
    ctx.lineWidth = thickness;
    ctx.lineJoin = "miter";
    ctx.lineCap = "square";
    ctx.globalAlpha = 0.6;
    var yDelta = 12;
    var xDelta = 12;

    var width = this.GetWidth();
    var height = this.GetHeight();

    var xDots = Math.floor(width / xDelta);
    var yDots = Math.floor(height / yDelta);

    var xStart = 1;
    var yStart = 1;
    var visible = this.fSrcPanel != null ? this.fSrcPanel.GetVisibleRect() : null;
    if (visible != null) {
      xStart = Math.max(xStart, Math.ceil(visible.fLeft / xDelta));
      yStart = Math.max(yStart, Math.ceil(visible.fTop / yDelta));
      xDots = Math.min(xDots, Math.floor(visible.fRight / xDelta) + 1);
      yDots = Math.min(yDots, Math.floor(visible.fBottom / yDelta) + 1);
    }

    for (var x = xStart; x < xDots; x++) {
      for (var y = yStart; y < yDots; y++) {
        //drawPixel(drawBuffer, x * xDelta,  y*yDelta, "#b1b1b6", .4)
        ctx.fillRect(x * xDelta, y * yDelta, 1, 1);
        //ctx.beginPath();
        //ctx.arc(x * xDelta, y * yDelta, 0.5, 0, Math.PI * 2, true);
        //ctx.closePath();
        //ctx.fill();
      }
    }
    ctx.restore();
  }

  // HIDEBK
  OverrideHideMaster() {
    return true;
  }

  IsShown() {
    return this.fShown;
  }

  SetShownState(showElement) {
    this.fShown = showElement;
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var sx = this.fHorzOffset;
    var sy = this.fVertOffset;
    var w = this.fWidth;
    var h = this.fHeight;
    var bkGroundColor = this.fSrcPanel.GetFillColor();
    var bkGroundColor2 = this.fSrcPanel.GetFillColor2(); // CBColorPicker

    var fillMode = this.fSrcPanel.GetBackgroundFillMode();
    var layer = this.GetLayer();
    if (fillMode == enumFillMode.solidFill) {
      bkGroundColor2 = null;
    }

    if (fillMode == enumFillMode.solidFill || fillMode == enumFillMode.linearGradientDown) {
      switch (altCanvasType) {
        case "SVG":
          if (!Globals._svgRenderInfo.fTransparent)
            SVG_DrawBackground(sx, sy, w, h, bkGroundColor, bkGroundColor2, altCanvasElement);
          break;
        case "XML":
          if (!Globals._pubSettings.fTransparentBackground)
            XML_DrawBackground(
              sx,
              sy,
              w,
              h,
              bkGroundColor,
              bkGroundColor2,
              altCanvasElement,
              layer
            );
          break;
      }
    }
  }

  ObjectName() {
    return this.fObjectName;
  }
}
